import 'css-chunksrc/client/scenes/moveKanbanTask/form/styles.scss';export default {
  "form": "_form_1mrrz_1",
  "section": "_section_1mrrz_10",
  "freeDateCheckBox": "_freeDateCheckBox_1mrrz_28",
  "label": "_label_1mrrz_37"
};